import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { auth } from '../lib/supabase';

export default function Register() {
  const { t } = useLang();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const { error: err } = await auth.signUp(email, password, fullName);
    setBusy(false);
    if (err) setError(err.message);
    else setDone(true);
  };

  return (
    <div className="container section" style={{ maxWidth: 420 }}>
      <h1>{t('auth.register')}</h1>
      {done ? (
        <div className="banner banner-green">{t('auth.checkEmail')} <Link to="/login">{t('auth.login')}</Link></div>
      ) : (
        <form className="card" onSubmit={submit}>
          <label className="field"><span>{t('auth.fullName')}</span>
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} required /></label>
          <label className="field"><span>{t('auth.email')}</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
          <label className="field"><span>{t('auth.password')}</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required /></label>
          {error && <div className="banner" style={{ background: 'var(--red-soft)', color: 'var(--red)' }}>{error}</div>}
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy}>{t('auth.register')}</button>
          <p className="muted" style={{ marginTop: 12, textAlign: 'center' }}>
            {t('auth.hasAccount')} <Link to="/login">{t('auth.login')}</Link>
          </p>
        </form>
      )}
    </div>
  );
}
